<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chapter-number---IVP sigil_not_in_toc" id="_idParaDest-3"><a id="_idTextAnchor041"></a><a id="_idTextAnchor042"></a><a id="_idTextAnchor043"></a><a id="_idTextAnchor044"></a><span class="pagebreak" id="page2" title="2"><span class="pagebreak" id="page3" title="3"></span></span></h2>
<p class="tp1">THE EARLIEST<br/>
    CHRISTOLOGIES</p>
<p class="tp3" id="sigil_toc_id_1" title="Title Page">Five Images of Christ in<br/>
    the Postapostolic Age</p>
<div>
<div id="_idContainer000">
<p class="center"><img alt="" src="Images/5127_graphic_TP_C.png"/></p>
</div>
</div>
<p class="tp2">JAMES L. PAPANDREA<br/>
<br/></p>
<div>
<div id="_idContainer004">
<p class="firstcenter"><a href="http://www.ivpress.com/academic" target="_blank"><img alt="IVPAcademic" src="Images/IVPAcademic.png"/></a></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?2c44478b